import { Injectable, inject } from '@angular/core';
import {NetworkService} from '../../../../../../projects/common/src/lib/services/network.service';
import {BaseApiService} from '../base-api.service';
import {FirebaseApi} from '../../firebase-api.service';

@Injectable({
  providedIn: 'root',
})
export class InvoiceApiService extends BaseApiService {

  constructor() {

    super();
  }

  retrieveUpcomingInvoice(): Promise<any> {
    return this.get('/invoices/upcoming');
  }

  /**
   * What switching to `planId` costs today. Read-only — the server previews
   * the prorated invoice without touching the subscription.
   */
  previewPlanChange(planId: string, quantity?: number): Promise<any> {
    const qty = quantity && quantity > 0 ? `&quantity=${quantity}` : '';
    return this.get(`/invoices/preview-plan-change?planId=${encodeURIComponent(planId)}${qty}`);
  }

  /** Current links to one of the account's invoices: Stripe's stored links expire. */
  invoiceLink(invoiceId: string): Promise<{hosted_invoice_url: string, invoice_pdf: string}> {
    return this.get(`/invoices/${encodeURIComponent(invoiceId)}/link`);
  }

}
